import React from "react"
import PropTypes from "prop-types"

import CubewiseLink from "./CubewiseLink"

const WP_BUTTON_LINK_CLASS = `wp-block-button__link`
const WP_FILE_ELEM_CLASS = `wp-block-file`
const WP_FILE_LINK_CLASS = `wp-block-file__button`

function WPCta(props) {
  const ctaWrapperNode = props.holder.childNodes.filter(node =>
    node.classNames.trim().split(/\s+/).includes(props.selector)
  )

  let ctaNode = null
  let ctaIsFile = false
  let ctaOpenBlank = false
  if (
    ctaWrapperNode &&
    ctaWrapperNode[0] &&
    ctaWrapperNode[0].classNames
      .trim()
      .split(/\s+/)
      .includes(WP_FILE_ELEM_CLASS)
  ) {
    ctaIsFile = true
    ctaNode =
      ctaWrapperNode[0].childNodes.filter(node =>
        node.classNames.trim().split(/\s+/).includes(WP_FILE_LINK_CLASS)
      )[0] || null
  } else if (ctaWrapperNode && ctaWrapperNode[0]) {
    ctaNode =
      ctaWrapperNode[0].childNodes.filter(node =>
        node.classNames.trim().split(/\s+/).includes(WP_BUTTON_LINK_CLASS)
      )[0] || null

    if (!ctaNode && ctaWrapperNode[0].childNodes[0]) {
      ctaNode =
        ctaWrapperNode[0].childNodes[0].childNodes.filter(node =>
          node.classNames.trim().split(/\s+/).includes(WP_BUTTON_LINK_CLASS)
        )[0] || null
    }

    if (ctaNode) {
      ctaOpenBlank =
        ctaWrapperNode[0].childNodes[0].childNodes[0].attrs.target &&
        ctaWrapperNode[0].childNodes[0].childNodes[0].attrs.target === `_blank`
    }
  }

  const otherProps = Object.keys(props)
    .filter(k => {
      return !Object.keys(PROPTYPES_PROXY).includes(k) && k !== `className`
    })
    .reduce((acc, cur) => ({ ...acc, [cur]: props[cur] }), {})

  if (!ctaNode || !ctaNode.text) return <></>

  return (
    <div
      className={`${[props.selector, props.className]
        .filter(Boolean)
        .join(` `)}`}
      {...otherProps}
    >
      <CubewiseLink
        linkPath={(ctaNode && ctaNode.attrs.href) || null}
        isFile={ctaIsFile}
        openBlank={ctaOpenBlank}
        translate={props.translate}
        pageContext={props.pageContext}
        modals={props.modals}
      >
        {ctaNode && (
          <span dangerouslySetInnerHTML={{ __html: ctaNode.rawText }} />
        )}
      </CubewiseLink>
    </div>
  )
}

export const DISPLAY_MODE = {
  normal: `normal`,
}

WPCta.defaultProps = {
  mode: DISPLAY_MODE.normal,
  translate: true,
}

const PROPTYPES_PROXY = {
  holder: PropTypes.object.isRequired,
  selector: PropTypes.string.isRequired,
  mode: PropTypes.oneOf(Object.keys(DISPLAY_MODE)).isRequired,
  translate: PropTypes.bool.isRequired,
  pageContext: PropTypes.object.isRequired,
  modals: PropTypes.object.isRequired,
}
WPCta.propTypes = PROPTYPES_PROXY

export default WPCta
